import config from "@/config";
import http from "@/utils/request";

//#region 代理考核达标记录
// | /ly/proxy/compliance/page { 分页列表 }
export const assessmentListApi = (params) =>
	http.get(`${config.API_URL}/api/ly/proxy/compliance/page`, params);

// | /ly/proxy/compliance/operation { 代理达标记录 操作 }
export const assessmentOperationApi = (data) =>
	http.post(`${config.API_URL}/api/ly/proxy/compliance/operation`, data);

// | /ly/proxy/compliance/log { 操作记录 }
export const assessmentLogApi = (id) =>
	http.get(`${config.API_URL}/api/ly/proxy/compliance/log?id=${id}`);

// | /ly/proxy/compliance/export { 导出 }
export const assessmentExportApi = (data, options) =>
	http.post(`${config.API_URL}/api/ly/proxy/compliance/export`, data, options);

// | /ly/proxy/compliance/orderList { 查看相关订单 }
export const assessmentOrderListApi = (params) =>
	http.get(`${config.API_URL}/api/ly/proxy/compliance/orderList`, params);

// | /ly/proxy/compliance/exportOrderList { 导出相关订单 }
export const assessmentExportOrderListApi = (data, options) =>
	http.post(`${config.API_URL}/api/ly/proxy/compliance/exportOrderList`, data, options);

//#endregion

//#region 代理考核达标佣金奖励
// | /ly/proxy/compliance/reward/page { 分页列表 }
export const assessmentRewardListApi = (params) =>
	http.get(`${config.API_URL}/api/ly/proxy/compliance/reward/page`, params);

// | /ly/proxy/compliance/reward/operation {  操作 }
export const assessmentRewardOperationApi = (data) =>
	http.post(
		`${config.API_URL}/api/ly/proxy/compliance/reward/operation`,
		data
	);

// | /ly/proxy/compliance/reward/log { 操作记录 }
export const assessmentRewardLogApi = (id) =>
	http.get(`${config.API_URL}/api/ly/proxy/compliance/reward/log?id=${id}`);
//#endregion
